import React from 'react';
import { Toaster } from 'react-hot-toast';

/**
 * Оформление уведомлений. Брендбук, раздел 8.3.
 * Тип и длительность задаются в utils/notify.js — здесь только вид.
 */
const Toast = () => {
  return (
    <Toaster
      position="bottom-center"
      reverseOrder={false}
      gutter={8}
      containerStyle={{
        // 95px — высота нижней навигации, 12px — зазор: вплотную тост
        // читается как часть меню. Врезку добавляем сверху: на Android
        // панель поднимается над системными кнопками, тост за ней
        bottom: 'calc(95px + 12px + max(var(--safe-area-bottom, 0px) - 20px, 0px))',
        zIndex: 'var(--z-toast)',
      }}
      toastOptions={{
        // Нейтральный тост — на поверхности карточки, не чёрный прямоугольник
        duration: 2000,
        // Тост сообщает результат, но не перехватывает фокус и не прерывает
        // чтение с экрана — polite, не assertive (брендбук 8.5)
        ariaProps: { role: 'status', 'aria-live': 'polite' },
        style: {
          background: 'var(--color-card)',
          color: 'var(--color-text-primary)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-md)',
          padding: '12px 16px',
          fontSize: '14px',
          lineHeight: '20px',
          fontWeight: '500',
          maxWidth: '90vw',
          gap: '8px',
        },
        // Успех — единственное место, где зелёный красит заливку
        success: {
          duration: 2500,
          style: {
            background: 'var(--color-success)',
            color: 'var(--color-on-semantic)',
            border: 'none',
          },
          iconTheme: {
            primary: 'var(--color-on-semantic)',
            secondary: 'var(--color-success)',
          },
        },
        // Ошибка держится дольше: её нужно успеть прочитать
        error: {
          duration: 4000,
          // Единственный тип, который прерывает чтение с экрана:
          // действие не выполнилось, узнать об этом нужно сразу
          ariaProps: { role: 'alert', 'aria-live': 'assertive' },
          style: {
            background: 'var(--color-danger)',
            color: 'var(--color-on-semantic)',
            border: 'none',
          },
          iconTheme: {
            primary: 'var(--color-on-semantic)',
            secondary: 'var(--color-danger)',
          },
        },
        loading: {
          style: {
            background: 'var(--color-card)',
            color: 'var(--color-text-primary)',
          },
        },
      }}
    />
  );
};

export default Toast;
